<template>
  <a-layout class='index animated fadeIn'>
    <SmallSquare content='付款后未确认收货/未核销的消费者发起退款申请的订单，超过订单设置退货时间的订单由消费者联系门店协商处理' :padding='true'></SmallSquare>
    <a-card :bordered='false'>
      <a-form ref='form' :model='search' :style="{'marginBottom':'25px'}" :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
        <a-form-item label="" name='keyword'>
          <a-input-group compact :style="{width:'360px'}">
            <a-select v-model:value="search.key_type" style="width: 30%" @change="inputSelect">
              <a-select-option value="order_no">订单号</a-select-option>
              <a-select-option value="user_id">买家ID</a-select-option>
              <a-select-option value="phone">联系手机</a-select-option>
              <a-select-option value="product_name">商品名称</a-select-option>
            </a-select>
            <a-input style="width: 70%" v-model:value="search.keyword" placeholder="请输入关键词进行搜索" />
          </a-input-group>
        </a-form-item>
        <a-form-item label="状态" name='status' >
          <a-select class='m-r-10' v-model:value="search.status" :style="{width:'140px'}" placeholder="全部">
            <a-select-option value="">全部</a-select-option>
            <a-select-option :value="0">待审核</a-select-option>
            <a-select-option :value="1">已拒绝</a-select-option>
            <a-select-option :value="4">已取消</a-select-option>
            <a-select-option :value="99">退款中</a-select-option>
            <a-select-option :value="3">退款完成</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" htmlType='submit'>搜索</a-button>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" ghost v-has:orderReturnExport="exportTable">导出</a-button>
        </a-form-item>
      </a-form>
      <a-table :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columns' :data-source='data' class="tableFixBox" :scroll="{ x: 'max-content'}">

        <template v-slot:phone="{ record } ">
          <p>{{record.phone || '-'}}</p>
        </template>
        <template v-slot:area="{ record }">
          <p>{{record.area || '门店自提订单，无收货区域'}}</p>
        </template>
        <template v-slot:action="{ record }">
          <a-button type="primary" v-has:orderReturnDetail="()=> {$router.push('/order/order_manage/return_order_more?id='+record.order_no)}" size='small'>{{record.status == 0 ?'办理':'详情'}}</a-button>
          <a-button type="danger" class="m-l-5" v-has:orderReturnReturn="()=>returnMoney(record)" size='small' v-if="record.status==0">退款</a-button>
        </template>
            <template v-slot:detail="{ record }">
          <div >
            <div v-for="(item,index) in record.goods_list" :key='index'>
              <a-card-meta>
                <template #avatar>
                  <img :src="info.picdomain+'/'+(item.product_image)" alt="" style="width:50px;height:50px">
                </template>
                <template #description>
                  <p class="s_omit2" style="width: 320px;">{{item.product_name}}</p>
                  <!-- <p class="s_omit">{{item.product_name}}</p> -->
                </template>
              </a-card-meta>
            </div>
          </div>
        </template>
      </a-table>
      <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数:${total} `" />
    </a-card>

    <a-modal  :keyboard="false" title="退款" :width='600' centered :footer="null" v-model:visible="showRefunds" destroyOnClose>
      <!-- :is_refund="refundsData.delivery_type==1&&refundsData.logistic_type==1" -->
      <refundsForem :refundsData='refundsData' type='more' v-on:submitrefunds='submitrefunds' is_refund></refundsForem>
    </a-modal>
  </a-layout>
</template>
<script>
import { ref, onMounted, inject, reactive, toRefs } from "vue";
import { message } from "ant-design-vue";
import { getRouter } from "@/utils/app";
import { setPageState, getPageState } from "@/utils/pageState";
import { getRefundList } from "@/api/order";
import { iscode } from "@/utils/app";
import store from "@/store"
// 初始化默认筛选项数值
let defSearch = {
  type: "",
  status: "",
  page: 1,
  limit: 5,
  key_type: "order_no",
  keyword: "",
};
export default {
  components: {  },
  setup(props, ctx) {
    // // 初始化 分页信息和筛选项信息
    let search = ref({ ...defSearch });
    // 列表数据和列头配置
    let data = ref([]);
    const state = reactive({
      listLoading: false,
      time: [],
      total: 1,
      showRefunds: false,
      refundsData: {},
      orderData: {},
    });
    let columns = [
      {
        title: "订单号",
        dataIndex: "order_no",
        key: "order_no",
      },
      {
        title: "微信昵称",
        dataIndex: "member_name",
        key: "member_name",
      },
      {
        title: "联系手机",
        dataIndex: "phone",
        key: "phone",
        slots: { customRender: "phone" },
      },
        {
        title: "订单来源",
        dataIndex: "source_name",
        key: "source_name",
      },
      {
        title: "收货区域",
        dataIndex: "area",
        key: "area",
        slots: { customRender: "area" },
      },
           {
        title: "订单商品",
        dataIndex: "detail",
        key: "detail",
        slots: { customRender: "detail" },
      },
         {
        title: "总数量/件",
        dataIndex: "product_all_total",
        key: "product_all_total",
        align:'center',
        customRender: ({ record }) => {
            return  record.goods_list.length?record.goods_list.map(v=>v.buy_num).reduce((prev,cur)=>prev+cur):1
          }
      },
      {
        title: "交易金额",
        dataIndex: "pay_price",
        key: "pay_price",
      },
      {
        title: "退款金额",
        dataIndex: "refund_money",
        key: "refund_money",
      },
      {
        title: "退款状态",
        dataIndex: "refund_status_texts",
        key: "refund_status_texts"
      },
      {
        title: "订单状态",
        dataIndex: "order_status_text",
        key: "order_status_text"
      },
  
      {
        title: "申请时间",
        dataIndex: "create_time",
        key: "create_time",
      },
      {
        title: "操作",
        key: "action",
        fixed: "right",
        slots: { customRender: "action" },
      },
    ];
    const $route = inject("$route");
    const $router = inject("$router");
    const $Modal = inject("$Modal");

    // 页面筛选项搜索
    const pageSearchChange = () => {
      search.value = { ...search.value, page: 1 };
      initData(search.value);
    };
    // 分页当前页切换
    const pageCurrentChange = (page, pageSize) => {
      search.value.page = page;
      initData(search.value);
    };
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, limit) => {
      search.value.page = 1;
      search.value.limit = limit;
      initData(search.value);
    };
    const initData = async (values) => {
      state.listLoading = true;
      try {
        let res = await getRefundList(values).then((res) => res.data);
        state.listLoading = false;
        if (iscode(res)) {
          data.value = res.data.data;
          state.total = res.data.total;
        } else {
          message.error(res.msg);
        }
      } catch (e) {
        state.listLoading = false;
      }
    };
    const inputSelect = (e) => {
      search.value.keyword = "";
    };
    //打开退款弹窗
    const orderRefunds = () => {
      state.refundsData = {
        pay_price: state.orderData.pay_price,
        order_no: $route.query.id,
      };
      state.showRefunds = true;
    };

    onMounted(() => {
      // 查看是否有留存状态，有则替换
      let pageState = getPageState(getRouter().route.path);
      if (pageState) {
        search.value = Object.assign(search.value, pageState);
      }
      initData();
    });

    // 退款
    const refundsData = ref();
    const showRefunds = ref(false);
    const returnMoney = (data) => {
      refundsData.value = data;
      showRefunds.value = true;
    };
    const submitrefunds = () => {
      showRefunds.value = false;
      initData(search.value);
    };
    // 导出
    const exportTable = async () => {
      let res = await getRefundList({ ...search.value, excel: 1 }).then(
        (res) => res.data
      );
      if (iscode(res, true)) {
        window.open(res.data.action);
      }
    };
    return {
      ...toRefs(state),
      search,
      data,
      columns,
      pageSearchChange,
      pageCurrentChange,
      pageSizeChange,
      inputSelect,
      returnMoney,
      refundsData,
      showRefunds,
      exportTable,
      orderRefunds,
      submitrefunds,
      info: store.state.user.info,
    };
  },
};
</script>